var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 0C5.58605 0 1.84264 2.86115 0.516357 6.82984H19.4841C18.1578 2.86115 14.4146 0 9.99998 0Z",
    fill: "url(#paint0_linear_44_1425)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99997 20C14.4146 20 18.1578 17.1386 19.4838 13.1707H0.516357C1.84264 17.1386 5.58605 20 9.99997 20Z",
    fill: "#F9F9F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.99999C20 8.89149 19.8171 7.8263 19.4839 6.82959H0.516382C0.18342 7.8263 0 8.89149 0 9.99999C0 11.109 0.18342 12.1737 0.516382 13.1709H19.4841C19.8171 12.1739 20 11.109 20 9.99999Z",
    fill: "#1A1A1A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_1425",
    x1: 0.516309,
    y1: 3.41487,
    x2: 19.484,
    y2: 3.41487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3150A3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEe);
export default __webpack_public_path__ + "static/media/EE.d167348560c238196eaaa5fcfc1e1219.svg";
export { ForwardRef as ReactComponent };